import axios from 'axios'
import store from './store'
import publish from '@/assets/js/pubilshSet'

import { Dialog, Toast } from 'vant'

import { TOKEN_KEY, USERINFO_KEY } from './variables'
import router from './router'
import { isWeixin } from './functions'

const service = axios.create({
  baseURL: publish.baseUrl,
  timeout: 15000
})

service.interceptors.request.use(
  config => {
    if (store.getters.token) {
      config.headers['token'] = store.getters.token
    }
    return config
  },
  error => {
    console.log('err' + error) // for debug
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    const { data, message, response: code } = response.data;

    if (!data && code === "100002") {
      if (!isWeixin() && router.currentRoute.path !== '/login') {
        Dialog.alert({
          message: '登陆状态失效，请尝试重新登陆',
          confirmButtonText: '重新登陆',
          theme: 'round-button',
        }).then(() => {
          window.localStorage.removeItem(TOKEN_KEY)
          window.localStorage.removeItem(USERINFO_KEY)
  
          router.push('/login')
        });
      }

      return Promise.reject(response)
    }
    if (message !== '成功') {
      if (code === '999999') Toast('请求接口数据失败');

      return Promise.reject(message)
    } else {
      return data
    }
  },
  error => {
    console.log('err' + error) // for debug
    return Promise.reject(error)
  }
)

export default service
